import Ajax from './ajax';
import { toast } from 'react-toastify';
import Order from '../domain/order';
import ProductionOrder from '../domain/productionorder';
import { LOGGED_OFF } from './authentication';
import { cloneDeep, sortBy } from 'lodash';
import i18next from 'i18next';
import { DELIVERY_DATE_INFO_LOADED } from './prodplanningdata';
import { mergeAutosaveResult } from './orderautosavemerge';

export const FETCH_ORDER_DATA_REQ = 'orderdata/FETCHORDERDATAREQ';
export const FETCH_ORDER_DATA_COMPLETED = 'orderdata/FETCHORDERDATACOMPLETED';
export const FETCH_ORDER_DATA_FAILED = 'orderdata/FETCHORDERDATAFAILED';

export const SAVING_ORDER = 'orderdata/SAVINGORDER';
export const ORDER_SAVED = 'orderdata/ORDERSAVED';
export const ORDER_SAVE_FAILED = 'orderdata/ORDERSAVEFAILED';

export const SAVING_COMBINED_ORDER = 'orderdata/SAVINGCOMBINEDORDER';
export const SAVING_COMBINED_ORDER_SUCCESS = 'orderdata/SAVINGCOMBINEDORDERSUCCESS';
export const SAVING_COMBINED_ORDER_FAIL = 'orderdata/SAVINGCOMBINEDORDERFAIL';

export const REMOVE_ORDER = 'orderdata/REMOVEORDER';

export const SENDING_ORDERS = 'orderdata/SENDINGORDERS';
export const SEND_ORDERS_SUCCESS = 'orderdata/SENDORDERSSUCCESS';
export const SEND_ORDERS_FAILED = 'orderdata/SENDORDERSFAILED';

export const GET_PROD_ORDERDATA_FULL_REQ = 'orderdata/GETPRODFULLREQ';
export const GET_PROD_ORDERDATA_FULL_SUCCESS = 'orderdata/GETPRODFULLSUCCESS';
export const GET_PROD_ORDERDATA_FULL_FAIL = 'orderdata/GETPRODFULLFAIL';

export const REMOVE_ORDER_HISTORY_DATA_REQ = 'orderdata/REMOVEORDERHISTORYREQ';
export const REMOVE_ORDER_HISTORY_DATA_SUCCESS = 'orderdata/REMOVEORDERHISTORYSUCCESS';
export const REMOVE_ORDER_HISTORY_DATA_FAIL = 'orderdata/REMOVEORDERHISTORYFAIL';

export const FETCH_PROD_ORDERS_UNINVOICED_DATA = 'orderdata/FETCHPRODORDERDATAUNINVOICED';
export const FETCH_PROD_ORDERS_UNINVOICED_DATA_SUCCESS = 'orderdata/FETCHPRODORDERDATAUNINVOICEDSUCCESS';
export const FETCH_PROD_ORDERS_INVOICED_DATA = 'orderdata/FETCHPRODORDERDATAINVOICED';
export const FETCH_PROD_ORDERS_INVOICED_DATA_SUCCESS = 'orderdata/FETCHPRODORDERDATAINVOICEDSUCCESS';
export const FETCH_PROD_ORDER_DATA_FAIL = 'orderdata/FETCHPRODORDERDATAFAIL';

export const PRODUCTION_ORDER_UPDATING = 'orderdata/PRODUCTION_ORDER_UPDATING';
export const PRODUCTION_ORDER_UPDATE_DONE = 'orderdata/PRODUCTION_ORDER_UPDATE_DONE';

export const UPDATE_ORDER_COMBINED_STATUS = 'orderdata/UPDATEORDERCOMBINEDSTATUS';

export const FETCH_ORDER_BY_ORDER_NUMBER = 'orderdata/ORDER_BY_ORDER_NUMBER';
export const FETCH_ORDER_BY_ORDER_NUMBER_SUCCESS = 'orderdata/ORDER_BY_ORDER_NUMBER_SUCCESS';
export const FETCH_ORDER_BY_ORDER_NUMBER_FAIL = 'orderdata/ORDER_BY_ORDER_NUMBER_FAIL';

export const UPDATE_SELECTED_DRAFT_ORDERS = 'orderdata/UPDATE_SELECTED_DRAFT_ORDERS';

export const SAVE_ORDER_SHALLOW_BATCH_STARTED = 'orderdata/SAVE_ORDER_SHALLOW_BATCH_STARTED';
export const SAVE_ORDER_SHALLOW_BATCH_SUCCESS = 'orderdata/SAVE_ORDER_SHALLOW_BATCH_SUCCESS';
export const SAVE_ORDER_SHALLOW_BATCH_FAIL = 'orderdata/SAVE_ORDER_SHALLOW_BATCH_FAIL';

export const PRODUCTION_ORDER_CHANGED = 'orderdata/PRODUCTION_ORDER_CHANGED';

export const SAVE_PENDING_ORDER = 'orderdata/SAVE_PENDING_ORDER';

export const AUTOSAVING = 'orderdata/AUTOSAVING';
export const AUTOSAVING_DONE = 'orderdata/AUTOSAVING_DONE';
export const AUTOSAVING_FAILED = 'orderdata/AUTOSAVING_FAILED';

export const ORDER_UPDATED_CLEAR_FROM_STORE = 'orderdata/ORDER_UPDATED_CLEAR_FROM_STORE';

export const DOWNLOADING_OFFER_PDF = 'orderdata/DOWNLOADING_OFFER_PDF';
export const DOWNLOADING_OFFER_PDF_DONE = 'orderdata/DOWNLOADING_OFFER_PDF_DONE';

export const DataSaveStatus = {
    Saving: 1,
    SaveSuccess: 2,
    SaveFailed: 3,
};

export const OrderSendStatus = {
    Sending: 1,
    SendSuccessful: 2,
    SendFailed: 3,
    SendFailedUnspecified: 4,
};

export const OrderDeleteStatus = {
    Deleting: 1,
    DeleteSucess: 2,
    DeleteFailed: 3,
};

const initialState = {
    pendingOrders: null,
    isFetchingOrderData: false,
    fetchOrderDataFailed: false,
    orderSaveStatus: {},
    orderSavingInProgress: false,
    sendingOrdersInProgress: false,
    orderSendFailed: false,
    savingCombinedOrder: false,
    savingCombinedOrderFail: false,
    savingCombinedOrderSuccess: false,
    orderHistoryDeleteStatus: {},
    unInvoicedOrders: null,
    invoicedOrders: null,
    productionOrderDataByOrderNumber: {},
    isFetchingProdOrderData: false,
    fetchProdOrderDataFailed: false,
    isFetchingProdOrdersUnInvoiced: false,
    isFetchingProdOrdersInvoiced: false,
    isUpdatingProdOrder: false,
    ordersByOrderNumber: {}, // would contain e.g. 12345: [order1, order2,..]
    selectedDraftOrders: null,
    printPreview: null,
    autosaving: {},
    autosavingFailed: {},
    downloadingOfferPdf: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ORDER_DATA_REQ:
            return {
                ...state,
                isFetchingOrderData: true,
                fetchOrderDataFailed: false,
            };
        case FETCH_ORDER_DATA_COMPLETED:
            const orderList = [];
            for (const o of action.orders) {
                orderList.push(new Order(o));
            }
            return {
                ...state,
                pendingOrders: orderList,
                isFetchingOrderData: false,
                fetchOrderDataFailed: false,
            };
        case FETCH_ORDER_DATA_FAILED:
            return {
                ...state,
                actions: [],
                isFetchingOrderData: false,
                fetchOrderDataFailed: true,
            };
        case SAVING_ORDER: {
            let newStatus = Object.assign({}, state.orderSaveStatus);
            if (action.id != null) newStatus[action.id] = DataSaveStatus.Saving;
            return {
                ...state,
                orderSaveStatus: newStatus,
                orderSavingInProgress: true,
            };
        }
        case ORDER_SAVED: {
            let newStatus = Object.assign({}, state.orderSaveStatus);

            let newPendingOrderList = [];

            if (action.multiple === true) {
                for (let o of state.pendingOrders) {
                    let newInd = 0;
                    let addOld = true;
                    for (let newOrder of action.orders) {
                        if (newOrder.id === o.id) {
                            newPendingOrderList.push(new Order(newOrder));
                            addOld = false;
                            action.orders.splice(newInd, 1);
                            break;
                        }
                        newInd++;
                    }
                    if (addOld) newPendingOrderList.push(o);
                }
                if (action.orders.length > 0) {
                    for (let o of action.orders) {
                        newPendingOrderList.push(new Order(o));
                    }
                }
            } else {
                newStatus[action.order.id] = DataSaveStatus.SaveSuccess;
                let addOrderAsNew = true;
                for (let o of state.pendingOrders) {
                    if (o.id === action.order.id) {
                        newPendingOrderList.push(new Order(action.order));
                        addOrderAsNew = false;
                    } else {
                        newPendingOrderList.push(o);
                    }
                }
                if (addOrderAsNew) newPendingOrderList.push(new Order(action.order));
            }
            return {
                ...state,
                pendingOrders: newPendingOrderList,
                orderSaveStatus: newStatus,
                orderSavingInProgress: false,
            };
        }
        case ORDER_SAVE_FAILED: {
            let newStatus = Object.assign({}, state.orderSaveStatus);
            if (action.id != null) newStatus[action.id] = DataSaveStatus.SaveFailed;
            return {
                ...state,
                orderSaveStatus: newStatus,
                orderSavingInProgress: false,
            };
        }
        case SAVE_PENDING_ORDER: {
            let newPendingOrderList = [];
            for (let o of state.pendingOrders) {
                if (o.id === action.order.id) {
                    newPendingOrderList.push(new Order(action.order));
                } else {
                    newPendingOrderList.push(o);
                }
            }
            return {
                ...state,
                pendingOrders: newPendingOrderList,
            };
        }
        case REMOVE_ORDER: {
            let newPendingOrderList = [];
            for (let o of state.pendingOrders) {
                if (o.id !== action.id) {
                    newPendingOrderList.push(o);
                }
            }
            return {
                ...state,
                pendingOrders: newPendingOrderList,
            };
        }
        case SENDING_ORDERS: {
            return {
                ...state,
                sendingOrdersInProgress: true,
                orderSendFailed: false,
            };
        }
        case SEND_ORDERS_SUCCESS: {
            const sentIds = action.orders.map((o) => o.id);
            const orderList = state.pendingOrders.filter((o) => !sentIds.includes(o.id));
            const orderNumber = action.orders[0].orderNumber;
            let newOrdersByOrderNumber = state.ordersByOrderNumber[orderNumber] ? {} : state.ordersByOrderNumber;
            return {
                ...state,
                pendingOrders: orderList,
                ordersByOrderNumber: newOrdersByOrderNumber,
                sendingOrdersInProgress: false,
                orderSendFailed: false,
            };
        }
        case SEND_ORDERS_FAILED: {
            return {
                ...state,
                sendingOrdersInProgress: false,
                orderSendFailed: true,
            };
        }
        case SAVING_COMBINED_ORDER: {
            return {
                ...state,
                savingCombinedOrder: true,
                savingCombinedOrderFail: false,
                savingCombinedOrderSuccess: false,
            };
        }
        case SAVING_COMBINED_ORDER_SUCCESS: {
            return {
                ...state,
                savingCombinedOrder: false,
                savingCombinedOrderFail: false,
                savingCombinedOrderSuccess: true,
            };
        }
        case SAVING_COMBINED_ORDER_FAIL: {
            return {
                ...state,
                savingCombinedOrder: false,
                savingCombinedOrderFail: true,
                savingCombinedOrderSuccess: false,
            };
        }
        case REMOVE_ORDER_HISTORY_DATA_REQ: {
            let newStatus = Object.assign({}, state.orderHistoryDeleteStatus);
            newStatus[action.id] = OrderDeleteStatus.Deleting;
            return {
                ...state,
                orderHistoryDeleteStatus: newStatus,
            };
        }
        case REMOVE_ORDER_HISTORY_DATA_SUCCESS: {
            let newStatus = Object.assign({}, state.orderHistoryDeleteStatus);
            newStatus[action.id] = OrderDeleteStatus.DeleteSucess;
            return {
                ...state,
                orderHistoryDeleteStatus: newStatus,
            };
        }
        case REMOVE_ORDER_HISTORY_DATA_FAIL: {
            let newStatus = Object.assign({}, state.orderHistoryDeleteStatus);
            newStatus[action.id] = OrderDeleteStatus.DeleteFailed;
            return {
                ...state,
                orderHistoryDeleteStatus: newStatus,
            };
        }
        case FETCH_PROD_ORDERS_UNINVOICED_DATA:
            return {
                ...state,
                isFetchingProdOrdersUnInvoiced: true,
            };
        case FETCH_PROD_ORDERS_INVOICED_DATA:
            return {
                ...state,
                isFetchingProdOrdersInvoiced: true,
            };
        case FETCH_PROD_ORDERS_UNINVOICED_DATA_SUCCESS: {
            let newProdOrderList = [];
            for (let o of action.prodOrders) {
                newProdOrderList.push(new ProductionOrder(o));
            }
            return {
                ...state,
                unInvoicedOrders: newProdOrderList,
                isFetchingProdOrdersUnInvoiced: false,
            };
        }
        case FETCH_PROD_ORDERS_INVOICED_DATA_SUCCESS: {
            let newProdOrderList = [];
            for (let o of action.prodOrders) {
                newProdOrderList.push(new ProductionOrder(o));
            }
            return {
                ...state,
                invoicedOrders: newProdOrderList,
                isFetchingProdOrdersInvoiced: false,
            };
        }
        case FETCH_PROD_ORDER_DATA_FAIL:
            return {
                ...state,
                isFetchingProdOrdersUnInvoiced: false,
                isFetchingProdOrdersInvoiced: false,
            };
        case PRODUCTION_ORDER_UPDATING:
            return {
                ...state,
                isUpdatingProdOrder: true,
            };
        case PRODUCTION_ORDER_UPDATE_DONE:
            return {
                ...state,
                isUpdatingProdOrder: false,
            };
        case PRODUCTION_ORDER_CHANGED: {
            let newUnInvoicedOrders = state.unInvoicedOrders
                ? state.unInvoicedOrders.filter((o) => o.orderNumber !== action.order.orderNumber)
                : null;
            let newInvoicedOrders = state.invoicedOrders
                ? state.invoicedOrders.filter((o) => o.orderNumber !== action.order.orderNumber)
                : null;

            let newProdOrdArr = Object.assign({}, state.productionOrderDataByOrderNumber);
            newProdOrdArr[action.order.orderNumber] = null;

            if (newInvoicedOrders && action.order.invoiceNumbers && action.order.invoiceNumbers.length) {
                newInvoicedOrders.push(new ProductionOrder(action.order));
                newInvoicedOrders = sortBy(newInvoicedOrders, (o) => -o.orderNumber);
            } else {
                newUnInvoicedOrders.push(new ProductionOrder(action.order));
                newUnInvoicedOrders = sortBy(newUnInvoicedOrders, (o) => -o.orderNumber);
            }

            return {
                ...state,
                isUpdatingProdOrder: false,
                unInvoicedOrders: newUnInvoicedOrders,
                invoicedOrders: newInvoicedOrders,
                productionOrderDataByOrderNumber: newProdOrdArr,
            };
        }
        case GET_PROD_ORDERDATA_FULL_REQ:
            return {
                ...state,
                isFetchingProdOrderData: true,
                fetchProdOrdersFailed: false,
            };
        case GET_PROD_ORDERDATA_FULL_SUCCESS:
            let newProdOrdArr = Object.assign({}, state.productionOrderDataByOrderNumber);
            newProdOrdArr[action.data.orderNumber] = new ProductionOrder(action.data);
            return {
                ...state,
                productionOrderDataByOrderNumber: newProdOrdArr,
                isFetchingProdOrderData: false,
                fetchProdOrdersFailed: false,
            };
        case GET_PROD_ORDERDATA_FULL_FAIL:
            return {
                ...state,
                isFetchingProdOrderData: false,
                fetchProdOrdersFailed: true,
            };
        case FETCH_ORDER_BY_ORDER_NUMBER:
            return state;
        case FETCH_ORDER_BY_ORDER_NUMBER_SUCCESS: {
            let newOrderList = cloneDeep(state.ordersByOrderNumber);
            newOrderList[action.orderNumber] = action.orders.map((item) => {
                return new Order(item);
            });
            return {
                ...state,
                ordersByOrderNumber: newOrderList,
            };
        }
        case FETCH_ORDER_BY_ORDER_NUMBER_FAIL:
            return state;
        case UPDATE_SELECTED_DRAFT_ORDERS:
            return {
                ...state,
                selectedDraftOrders: action.selected,
            };
        case AUTOSAVING: {
            const newAutosaving = cloneDeep(state.autosaving);
            newAutosaving[action.orderId] = true;
            return {
                ...state,
                autosaving: newAutosaving,
            };
        }
        case AUTOSAVING_DONE: {
            const newAutosaving = cloneDeep(state.autosaving);
            delete newAutosaving[action.orderId];
            const newAutosavingFailed = cloneDeep(state.autosavingFailed);
            delete newAutosavingFailed[action.orderId];
            return {
                ...state,
                autosaving: newAutosaving,
                autosavingFailed: newAutosavingFailed,
            };
        }
        case AUTOSAVING_FAILED: {
            const newAutosaving = cloneDeep(state.autosaving);
            delete newAutosaving[action.orderId];
            const newAutosavingFailed = cloneDeep(state.autosavingFailed);
            newAutosavingFailed[action.orderId] = true;
            return {
                ...state,
                autosaving: newAutosaving,
                autosavingFailed: newAutosavingFailed,
            };
        }
        case ORDER_UPDATED_CLEAR_FROM_STORE: {
            const orderNumber = action.orderNumber;
            const current = state.ordersByOrderNumber || {};
            // if no orderNumber provided or key not present, don't change state
            if (orderNumber == null || !Object.prototype.hasOwnProperty.call(current, orderNumber)) {
                return state;
            }
            // shallow copy is enough since we only remove a top-level key
            const newOrders = { ...current };
            delete newOrders[orderNumber];

            return {
                ...state,
                ordersByOrderNumber: newOrders,
            };
        }
        case DOWNLOADING_OFFER_PDF:
            return { ...state, downloadingOfferPdf: true };
        case DOWNLOADING_OFFER_PDF_DONE:
            return { ...state, downloadingOfferPdf: false };
        case LOGGED_OFF:
            return initialState;
        default:
            return state;
    }
};

export const saveOrderToStore = (order) => {
    return (dispatch) => {
        dispatch({
            type: SAVE_PENDING_ORDER,
            order: order,
        });
    };
};

export const autosaveOrder = (order) => {
    return async (dispatch, getState) => {
        dispatch({ type: AUTOSAVING, orderId: order.id });
        const sentSnapshot = cloneDeep(order);
        try {
            var resp = await Ajax.put('api/Order/autosave/' + order.id, order, { skipInterceptor: true });
            const currentOrder = getState().orderdata.pendingOrders.find((o) => o.id === order.id);
            if (currentOrder != null && resp.data.updatedOrder != null) {
                const merged = mergeAutosaveResult(cloneDeep(currentOrder), sentSnapshot, resp.data.updatedOrder);
                dispatch(saveOrderToStore(merged));
            }
            if (resp.data.capacityUpdateFailed) {
                dispatch({ type: AUTOSAVING_FAILED, orderId: order.id });
            } else {
                dispatch({ type: AUTOSAVING_DONE, orderId: order.id });
            }
            dispatch({
                type: DELIVERY_DATE_INFO_LOADED,
                orderIds: [order.id],
                deliveryInfos: resp.data.earliestDeliveryDates,
            });
        } catch (err) {
            console.log(err);
            dispatch({ type: AUTOSAVING_FAILED, orderId: order.id });
        }
    };
};

export const getPendingOrders = () => {
    return (dispatch) => {
        dispatch({
            type: FETCH_ORDER_DATA_REQ,
        });
        Ajax.get('api/Order/draft/')
            .then(function (data) {
                dispatch({
                    type: FETCH_ORDER_DATA_COMPLETED,
                    orders: data.data.draftOrders,
                });
            })
            .catch(function (err) {
                dispatch({
                    type: FETCH_ORDER_DATA_FAILED,
                });
            });
    };
};

export const removeOrder = (id) => {
    return (dispatch) => {
        Ajax.delete('api/Order/' + id)
            .then(function (res) {
                dispatch({
                    type: REMOVE_ORDER,
                    id: id,
                });
            })
            .then(function () {
                dispatch(getPendingOrders());
            })
            .catch(function (err) {
                console.log(err);
            });
    };
};

const sendOrdersInternal = (orders, options, combine, dispatch, language) => {
    dispatch({
        type: SENDING_ORDERS,
        orders: orders,
    });
    const url = combine ? 'api/order/sendcombined/' : 'api/order/send/';
    Ajax.post(url, { orders: orders, options: options, language: language })
        .then(function (res) {
            dispatch({
                type: SEND_ORDERS_SUCCESS,
                orders: orders,
            });
            dispatch(getPendingOrders());
        })
        .catch(function (err) {
            console.log(err);
            dispatch({
                type: SEND_ORDERS_FAILED,
                orders: orders,
            });
        });
};

export const sendOrdersCombined = (orders, options, language) => {
    return (dispatch) => {
        try {
            sendOrdersInternal(orders, options, true, dispatch, language);
        } catch (err) {
            console.log(err);
        }
    };
};

export const sendOrders = (orders, options, language) => {
    return (dispatch) => {
        sendOrdersInternal(orders, options, false, dispatch, language);
    };
};

export const sendEditOrders = (orders, options, language, reservations) => {
    return async (dispatch) => {
        dispatch({
            type: SENDING_ORDERS,
            orders: orders,
        });
        try {
            await Ajax.post('api/order/sendedit/', { orders, options, language, reservations });
            dispatch({
                type: SEND_ORDERS_SUCCESS,
                orders: orders,
            });
            return true;
        } catch (err) {
            console.log(err);
            dispatch({
                type: SEND_ORDERS_FAILED,
                orders: orders,
            });
            return false;
        }
    };
};

export const newOrderFromLocations = (locationIds) => {
    return (dispatch, getState) => {
        toast.info(i18next.t('toast.addingLocationToOrder'), { autoClose: 1000, hideProgressBar: true });
        dispatch({
            type: SAVING_ORDER,
            id: null,
        });
        Ajax.post('api/order/fromlocations/', locationIds)
            .then(function (res) {
                toast.info(i18next.t('toast.addedLocationToOrder'), { autoClose: 1500, hideProgressBar: true });
                dispatch({
                    type: ORDER_SAVED,
                    multiple: true,
                    orders: res.data,
                });
            })
            .catch(function (err) {
                toastError('toast.addingLocationToOrderFailed');
                dispatch({
                    type: ORDER_SAVE_FAILED,
                    id: null,
                });
            });
    };
};

export const addFilterToOrder = (locationId, machineId, filterId) => {
    return (dispatch) => {
        toast.info(i18next.t('toast.addingFilterToOrder'), { autoClose: 1000, hideProgressBar: true });
        dispatch({
            type: SAVING_ORDER,
            id: null,
        });
        Ajax.post('api/order/location/' + locationId + '/machine/' + machineId + '/filter/' + filterId)
            .then(function (res) {
                toast.info(i18next.t('toast.addedFilterToOrder'), { autoClose: 1500, hideProgressBar: true });
                dispatch({
                    type: ORDER_SAVED,
                    order: res.data,
                });
            })
            .catch(function (err) {
                toastError('toast.addingFilterToOrderFailed');
                dispatch({
                    type: ORDER_SAVE_FAILED,
                    id: null,
                });
            });
    };
};

export const addNewProductToOrder = (locationId, machineId, productCode) => {
    return (dispatch) => {
        toast.info(i18next.t('toast.addingProductToOrder'), { autoClose: 1000, hideProgressBar: true });
        dispatch({
            type: SAVING_ORDER,
            id: null,
        });
        Ajax.put('api/order/location/' + locationId + '/machine/' + machineId + '/product/' + productCode)
            .then(function (res) {
                toast.info(i18next.t('toast.addedProductToOrder'), { autoClose: 1500, hideProgressBar: true });
                dispatch({
                    type: ORDER_SAVED,
                    order: res.data,
                });
            })
            .catch(function (err) {
                dispatch({
                    type: ORDER_SAVE_FAILED,
                    id: null,
                });
            });
    };
};

export const addMachineToOrder = (locId, machineId) => {
    return (dispatch) => {
        toast.info(i18next.t('toast.addingMachineToOrder'), { autoClose: 1000, hideProgressBar: true });
        dispatch({
            type: SAVING_ORDER,
            id: null,
        });
        Ajax.post('api/order/location/' + locId + '/machine/' + machineId)
            .then(function (res) {
                toast.info(i18next.t('toast.addedMachineToOrder'), { autoClose: 1500, hideProgressBar: true });
                dispatch({
                    type: ORDER_SAVED,
                    order: res.data,
                });
            })
            .catch(function (err) {
                toastError('toast.addingMachineToOrderFailed');
                dispatch({
                    type: ORDER_SAVE_FAILED,
                    id: null,
                });
            });
    };
};

export const allocatePalletsForOrders = (orderIds) => {
    return (dispatch) => {
        toast.info(i18next.t('toast.allocatingPalletsToOrder'), { autoClose: 1000, hideProgressBar: true });
        dispatch({
            type: SAVING_ORDER,
            id: null
        });
        Ajax.put(`api/order/allocatepallets/`, orderIds)
            .then(function (res) {
                toast.info(i18next.t('toast.allocatedPalletsToOrder'), { autoClose: 1500, hideProgressBar: true });
                dispatch({
                    type: ORDER_SAVED,
                    multiple: true,
                    orders: res.data,
                });
            })
            .catch(function (err) {
                console.log(err)
                toastError('toast.allocatingPalletsToOrderFailed');
                dispatch({
                    type: ORDER_SAVE_FAILED,
                    id: null,
                });
            });
    };
};

export const removeOrderFromHistory = (orderId, reason) => {
    return async (dispatch) => {
        toast.info(i18next.t('toast.removingOrderInfo'), { autoClose: 1000, hideProgressBar: true });
        dispatch({
            type: REMOVE_ORDER_HISTORY_DATA_REQ,
            id: orderId,
        });
        try {
            await Ajax.delete('api/Order/fromhistory/' + orderId, { removeReason: reason });
            toast.info(i18next.t('toast.removedOrderInfo'), { autoClose: 1500, hideProgressBar: true });
            dispatch({
                type: REMOVE_ORDER_HISTORY_DATA_SUCCESS,
                id: orderId,
            });
            return true;
        } catch (err) {
            toast.error(i18next.t('toast.removingOrderInfoFailed'), { autoClose: 3000 });
            dispatch({
                type: REMOVE_ORDER_HISTORY_DATA_FAIL,
                id: orderId,
            });
            console.log(err);
            return false;
        }
    };
};

export const nullifyOrder = (orderNumber) => {
    return async (dispatch) => {
        try {
            await Ajax.put('api/Order/nullify/' + orderNumber);
            return true;
        } catch (err) {
            console.log(err);
            return false;
        }
    };
};

export const getProdOrdersUnInvoiced = () => {
    return (dispatch) => {
        dispatch({
            type: FETCH_PROD_ORDERS_UNINVOICED_DATA,
        });
        Ajax.get('api/production/orders/uninvoiced')
            .then(function (data) {
                dispatch({
                    type: FETCH_PROD_ORDERS_UNINVOICED_DATA_SUCCESS,
                    prodOrders: data.data,
                });
            })
            .catch(function (err) {
                dispatch({
                    type: FETCH_PROD_ORDER_DATA_FAIL,
                });
                toast.error(i18next.t('toast.gettingOrderInfoFailed'), { autoClose: 3000 });
            });
    };
};
export const getProdOrdersInvoiced = () => {
    return (dispatch) => {
        dispatch({
            type: FETCH_PROD_ORDERS_INVOICED_DATA,
        });
        Ajax.get('api/production/orders/invoiced')
            .then(function (data) {
                dispatch({
                    type: FETCH_PROD_ORDERS_INVOICED_DATA_SUCCESS,
                    prodOrders: data.data,
                });
            })
            .catch(function (err) {
                dispatch({
                    type: FETCH_PROD_ORDER_DATA_FAIL,
                });
                toast.error(i18next.t('toast.gettingOrderInfoFailed'), { autoClose: 3000 });
            });
    };
};

export const productionOrderChanged = (order) => {
    return (dispatch) => {
        dispatch({
            type: PRODUCTION_ORDER_CHANGED,
            order: order,
        });
    };
};

export const updateOrderStatus = (newStatus, orderNumber, reason) => {
    return async (dispatch) => {
        dispatch({
            type: PRODUCTION_ORDER_UPDATING,
        });
        try {
            await Ajax.put('api/production/' + orderNumber, {
                newStatus,
                reason: reason,
            });
            dispatch({
                type: PRODUCTION_ORDER_UPDATE_DONE,
                orderNumber,
            });
            return true;
        } catch (err) {
            console.log(err);
            dispatch({
                type: PRODUCTION_ORDER_UPDATE_DONE,
                orderNumber,
            });
            return false;
        }
    };
};

export const getProductionOrderDataFull = (orderNumber) => {
    return (dispatch) => {
        dispatch({
            type: GET_PROD_ORDERDATA_FULL_REQ,
        });
        Ajax.get('api/production/' + orderNumber)
            .then(function (data) {
                dispatch({
                    type: GET_PROD_ORDERDATA_FULL_SUCCESS,
                    data: data.data,
                });
            })
            .catch(function (err) {
                console.log(err);
                dispatch({
                    type: GET_PROD_ORDERDATA_FULL_FAIL,
                });
            });
    };
};

export const getOrdersByOrderNumber = (orderNumber) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_ORDER_BY_ORDER_NUMBER });
        try {
            const resp = await Ajax.get('api/order/ordernumber/' + orderNumber);
            dispatch({
                type: FETCH_ORDER_BY_ORDER_NUMBER_SUCCESS,
                orders: resp.data,
                orderNumber: orderNumber,
            });
        } catch (err) {
            console.log(err.toJSON());
            dispatch({ type: FETCH_ORDER_BY_ORDER_NUMBER_FAIL });
        }
    };
};

export const updateSelectedDraftOrders = (selected) => {
    return (dispatch) => {
        dispatch({ type: UPDATE_SELECTED_DRAFT_ORDERS, selected });
    };
};

export const getPoForOrder = async (orderNumber) => {
    try {
        const resp = await Ajax.get('api/production/purchase/' + orderNumber);
        return resp.data;
    } catch (err) {
        console.log(err);
        return null;
    }
};

// Returns the ids of DeliveryMethod parameter values that cannot be used for a delivery to the
// given zip code, i.e. their cargo provider requires pricing to be configured (BlockIfPricingMissing)
// but no matching sales price exists for the zip code. Used to mark unavailable options in the
// delivery method selector while an order is being edited.
export const getBlockedDeliveryMethods = async (zipCode) => {
    if (!zipCode) return [];
    try {
        const resp = await Ajax.get('api/order/blockeddeliverymethods/' + zipCode);
        return resp.data;
    } catch (err) {
        console.log(err);
        return [];
    }
};

export const getOrderPrintView = (orderNumber, fileName = 'document.pdf') => {
    return async (dispatch) => {
        try {
            const response = await Ajax.post(
                'api/order/print/',
                { orderNumber, options: {} },
                { responseType: 'blob', acceptHeader: 'application/pdf' }
            );

            if (response.status === 200) {
                var blob = new Blob([response.data], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(url);
                return true;
            }

            return false;
        } catch (err) {
            console.log(err);
            return false;
        }
    };
};

export const addOrdersFromExcel = (customerId, orderData) => {
    return async (dispatch) => {
        try {
            const result = await Ajax.post(`api/order/fromexcel/`, { customerId, orderDataBase64: orderData });
            dispatch({ type: ORDER_SAVED, multiple: true, orders: result.data });
            return true;
        } catch (err) {
            console.log(err);
            return false;
        }
    };
};

export const moveOrderToPortfolio = (newPortfolioId, orderNumber) => {
    return async () => {
        try {
            await Ajax.post(`api/order/${orderNumber}/toportfolio/${newPortfolioId}`);
            return true;
        } catch (err) {
            console.log(err);
            return false;
        }
    };
};

const toastError = (message) => {
    toast.error(i18next.t(message), { timeout: 5000 });
};

export const downloadingOfferPdfDone = () => (dispatch) => {
    dispatch({ type: DOWNLOADING_OFFER_PDF_DONE });
};

export const requestBasketOfferPdf = (orderIds, language) => {
    return async (dispatch) => {
        dispatch({ type: DOWNLOADING_OFFER_PDF });
        try {
            await Ajax.post('api/order/offerpdf', { orderIds, language });
            toast.info(i18next.t('createPdf.pdfCreateInProgress'), { autoClose: 10000, hideProgressBar: true });
        } catch (err) {
            console.log(err);
            dispatch({ type: DOWNLOADING_OFFER_PDF_DONE });
            toast.error(i18next.t('createPdf.createPdfFail'), { autoClose: 5000 });
        }
    };
};
